import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowPathLeft: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowPathLeft"><Path d="M10.9991 2.7959V7.99967H21.9991V15.9997H10.9991V21.2034L0.480469 11.9997L10.9991 2.7959Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowPathLeft;
